import { useState } from 'react';
import { OptimusProvider } from '@mews-commander/ui';
import { SignInViews } from '../constants';
import { NewPublicFormWrapper } from '../style';
import { UnlockScreen } from './Lockscreen/UnlockScreen';
import { useHasLockedUsers } from './Lockscreen/useLockscreenStore';
import { SignInRedirect } from './SignInRedirect';
import { SignIn } from './SignIn/SignIn';

/*
 * This renders either the Lockscreen or the SignIn component, which share the same route
 * We plan to move the Lockscreen out of this component and transform it into a separate route
 * This will allow us to have a cleaner separation of concerns, but we need to adjust some global flows
 * TODO: Move Lockscreen to a separate route
 */
export const SignInAndLockscreen = ({ redirect: redirectTo }: { redirect?: string }) => {
    const hasLockedUsers = useHasLockedUsers();
    const initialView = hasLockedUsers ? SignInViews.LOCK_SCREEN : SignInViews.SIGN_IN_SCREEN;
    const [view, setView] = useState(initialView);

    return (
        <SignInRedirect redirect={redirectTo}>
            <SignInLayout>
                {view === SignInViews.LOCK_SCREEN && (
                    <UnlockScreen onUserChange={() => setView(SignInViews.SIGN_IN_SCREEN)} />
                )}
                {view === SignInViews.SIGN_IN_SCREEN && (
                    <SignIn onSelectLockedUser={() => setView(SignInViews.LOCK_SCREEN)} />
                )}
            </SignInLayout>
        </SignInRedirect>
    );
};

const SignInLayout = ({ children }: React.PropsWithChildren<{}>) => (
    <NewPublicFormWrapper vertical>
        <OptimusProvider density="spacious">{children}</OptimusProvider>
    </NewPublicFormWrapper>
);
